<div [formGroup]="form">

    <kal-card>

        <kal-form-field>

            <kal-input formControlName="Libelle"
                       label="Libellé du dossier">
            </kal-input>

        </kal-form-field>

        <kal-form-field>

            <kal-select formControlName="IdStatut"
                        placeholder="Sélectionner un statut"
                        label="Statut">

                <kal-option *ngFor="let status of statusList"
                            [value]="status.Id">

                    {{ status.Libelle }}

                </kal-option>

            </kal-select>

        </kal-form-field>

        <kal-form-field *ngIf="shouldDisplayDescription else addDescriptionBtnTemplate" class="gup-C-formFieldSize--bottomNull">

            <kal-textarea formControlName="Description"
                          label="Description">
            </kal-textarea>

        </kal-form-field>

        <div *ngIf="shouldDisplayPostDateRange else addPostDateRangeBtnTemplate" class="gup-U-margin-top--normal">

            <app-date-range controlLabel="Période de publication"
                            displayDateEnd
                            formControlName="DateDossier">
            </app-date-range>

        </div>

        <ng-template #addDescriptionBtnTemplate>

            <app-shared-icon-button (click)="toggleDescription()">
                Ajouter une description
            </app-shared-icon-button>

        </ng-template>

        <ng-template #addPostDateRangeBtnTemplate>

            <app-shared-icon-button (click)="togglePostDateRange()">
                Ajouter une période de publication
            </app-shared-icon-button>
            <div class="gup-U-color--400 xsmall">
                Le dossier sera publié sur la période saisie à condition qu'il soit au statut validé.
            </div>

        </ng-template>

    </kal-card>

    <kal-card *ngFor="let file of fileList">

        <a *ngIf="!!file.Url else fileNameWithoutLinkTemplate" [href]="file.Url" class="gup-O-link -secondary">
            <kal-icon>attach_file</kal-icon>
            {{ file.Filename }}
        </a>

        <ng-template #fileNameWithoutLinkTemplate>
            <kal-icon>attach_file</kal-icon>
            {{ file.Filename }}
        </ng-template>

    </kal-card>


     <kal-card *ngIf="isFileListEmpty else addDocumentBtnOutsideKalCardTemplate">

       <ng-container *ngTemplateOutlet="addDocumentBtnTemplate"></ng-container>

   </kal-card>

    <ng-template #addDocumentBtnOutsideKalCardTemplate>

        <kal-card>

            <ng-container *ngTemplateOutlet="addDocumentBtnTemplate"></ng-container>

        </kal-card>

    </ng-template>

    <ng-template #addDocumentBtnTemplate>

        <app-shared-icon-button (click)="openFileSelectionDialog()">
            Ajouter un document <span *ngIf="isFileListEmpty" class="gup-U-color--orange">*</span>
        </app-shared-icon-button>

        <div class="xsmall gup-U-color--400">La taille ne peut pas excéder 3 Mo.</div>

    </ng-template>

</div>
